// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const GeneralTimeZone = t.struct({
    allowedTimeZones: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'GeneralTimeZone',
    strict: true
});

export const getDefaultState = () => new GeneralTimeZone({
    allowedTimeZones: [],
    key: '',
    value: ''
});

export default GeneralTimeZone;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/general-time-zone.js